
class Pagination {
  [x: string]: any;
  static $inject = ['$templateCache'];

  constructor($templateCache) {
    $templateCache.put('pagination.custom.html', require('./pagination.custom.html'))
  }
}

export default {
  controller: Pagination,
  template: require('./pagination.html'),
  bindings: {stItemsByPage: '<'}
};
